import { jsx as _jsx } from "react/jsx-runtime";
import s from './StatusPill.module.css';
export function StatusPill({ tone, children }) {
    return _jsx("span", { className: [s.pill, s[tone]].join(' '), children: children });
}
